/* eslint-disable no-useless-catch */
import { serialize } from '../utils';
import { FindOneOptions, FindOptions } from './common';
import { entityService } from './services';
// #endregion Local Imports

const pathname = '/products';

export const ProductApi = {
  find: async (option: FindOptions) => {
    let url = pathname;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findProductToCreateOrder: async (body: any) => {
    const url = `${pathname}/find-to-create-order`;

    try {
      const response = await entityService.post(url, body);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findProductToUpdateOrder: async (id: string, body: any) => {
    const url = `${pathname}/find-to-update-order/${id}`;

    try {
      const response = await entityService.post(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  findProductToCreateBill: async (option: any) => {
    const url = `${pathname}/find-to-create-bill`;

    try {
      const response = await entityService.post(url, option);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findProductForUpdateBill: async (id: string, option: any) => {
    const url = `${pathname}/find-to-update-bill/${id}`;

    try {
      const response = await entityService.post(url, option);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findProductForReturnBill: async (option: any) => {
    const url = `${pathname}/find-to-create-bill`;

    try {
      const response = await entityService.post(url, option);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findFreeProposalPolicyProducts: async (
    option: FindFreeProposalPolicyProductsQuery,
    body: FindFreePolicyProductsBody
  ) => {
    let url = `${pathname}/free-proposal-policy-products`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.post(url, body);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findFreePricePolicyProducts: async (
    option: FindFreePricePolicyProductsQuery,
    body: FindFreePolicyProductsBody
  ) => {
    let url = `${pathname}/free-price-policy-products`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.post(url, body);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findProposalItemsToOrder: async (
    option: FindProductOptions = {},
    ownerID: string,
    supplierIDs: string[]
  ) => {
    let url = `${pathname}/proposal-items/order`;
    const query = serialize({ ...option });
    url += query;

    try {
      const response = await entityService.post(url, { ownerID, supplierIDs });

      return response;
    } catch (error) {
      throw error;
    }
  },

  findOrders: async (
    option: {
      name?: string;
      categoryID?: string;
      page?: number;
      take?: number;
    } = {},
    ownerID: string,
    customerIDs: string[],
    orderType: number,
    coBuyIDs?: string[],
    startedAt?: string,
    finishedAt?: string
  ) => {
    let url = `${pathname}/orders`;
    const query = serialize({ ...option });
    url += query;

    try {
      const response = await entityService.post(url, {
        ownerID,
        customerIDs,
        orderType,
        coBuyIDs,
        startedAt,
        finishedAt,
      });

      return response;
    } catch (error) {
      throw error;
    }
  },

  findProductPricePolicy: async ({ option, body }) => {
    let url = `${pathname}/price-policies`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.post(url, body);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findProductProposalItem: async ({ option, body }) => {
    let url = `${pathname}/proposal-items`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.post(url, body);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findProductProposalItemsSupplier: async ({ option, body }) => {
    let url = `${pathname}/proposal-items-supplier`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.post(url, body);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findProductProposalItemsCustomer: async ({ option, body }) => {
    let url = `${pathname}/proposal-items-customer`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.post(url, body);

      return response;
    } catch (error) {
      throw error;
    }
  },

  create: async (body: any) => {
    try {
      const response = await entityService.post(`${pathname}`, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  createImport: async (body: any) => {
    try {
      const response = await entityService.post(`${pathname}/import`, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  createFromStandardData: async (body: CreateProductFromStandardDataBody) => {
    try {
      const response = await entityService.post(
        `${pathname}/create-from-standard-data`,
        body
      );
      return response;
    } catch (error) {
      throw error;
    }
  },

  findOne: async (id: string, option: FindOneOptions) => {
    let url = `${pathname}/${id}`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  update: async (id: string, body: any = {}) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updateMulti: async (body: any = {}) => {
    const url = `${pathname}/multiple-by-admin`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updatePrice: async (id: string, body: any = {}) => {
    const url = `${pathname}/${id}/price`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updateQuantity: async (id: string, body: any = {}) => {
    const url = `${pathname}/${id}/quantity`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updateStatus: async (id: string, body: any = {}) => {
    const url = `${pathname}/${id}/status`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  remove: async (id: string) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.delete(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  createCoBuyPromotion: async (id: string, body: any = {}) => {
    const url = `${pathname}/${id}/co-buy-promotion`;

    try {
      const response = await entityService.post(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updateCoBuyPromotion: async (
    id: string,
    promotionId: string,
    body: any = {}
  ) => {
    const url = `${pathname}/${id}/co-buy-promotion/${promotionId}`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  removeCoBuyPromotion: async (id: string, promotionId: string) => {
    const url = `${pathname}/${id}/co-buy-promotion/${promotionId}`;

    try {
      const response = await entityService.delete(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  checkProductInMarketing: async (id: string) => {
    const url = `${pathname}/check-product-in-marketing/${id}`;

    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  checkCanDeleteProduct: async (id: string) => {
    const url = `${pathname}/check-can-delete-product/${id}`;
    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  checkCanDeleteMultiProducts: async (body: { productIDs: string[] }) => {
    const url = `${pathname}/check-can-delete-products`;
    try {
      const response = await entityService.post(url, body);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findSuggestProductsForProductAutoSynced: async (
    option: {
      page?: number;
      take?: number;
    } = {}
  ) => {
    let url = `${pathname}/find-suggest-products-for-auto-synced`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findSelectedProduct: async (
    body: { productIDs: string[] },
    option: FindOptions
  ) => {
    let url = `${pathname}/selected`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.post(url, body);

      return response;
    } catch (error) {
      throw error;
    }
  },

  duplicate: async (body: { products: { id: string; name?: string }[] }) => {
    try {
      const response = await entityService.post(`${pathname}/duplicate`, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  deleteMulti: async (body: { productIDs: string[] }) => {
    try {
      const response = await entityService.post(
        `${pathname}/delete/multi`,
        body
      );
      return response;
    } catch (error) {
      throw error;
    }
  },

  syncProductMulti: async (body: any = {}) => {
    const url = `${pathname}/sync-product-multi`;
    try {
      const response = await entityService.post(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  checkDuplicate: async (option?: CheckDuplicateProductCodeQuery) => {
    let url = `${pathname}/check-duplicate`;
    const query = serialize(option || {});
    url += query;
    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  generateCode: async (option: GenerateProductCodeQuery) => {
    let url = `${pathname}/generate-code`;
    const query = serialize(option);
    url += query;
    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export interface FindProductOptions {
  page?: number;
  take?: number;
  select?: string[];
  relations?: string[];
  order?: any;
  where?: {
    entityID: string;
    status?: number;
  };
  reserved?: boolean;
}

export interface ValidationProductResult {
  coBuyList: any[];
  comboList: any[];
  isValid: boolean;
  productCouponList: any[];
  wholesaleDigitalMenuList: any[];
}

type FindOptionsVer1 = Pick<
  FindOptions,
  Exclude<keyof FindOptions, 'select' | 'relations' | 'where' | 'tab'>
>;

export interface FindFreePolicyProductsBody {
  excludedProductIDs: string[];
}

export interface FindFreeProposalPolicyProductsQuery extends FindOptionsVer1 {
  proposalPolicyID: string;
  entityCategoryID: string;
  categoryID: string;
  name: string;
}

export interface FindFreePricePolicyProductsQuery extends FindOptionsVer1 {
  pricePolicyID: string;
  entityCategoryID: string;
  categoryID: string;
  name: string;
}

export type FindProductsWithExcludedProductsType = {
  options: {
    page?: number;
    take?: number;
    collaboratorID?: string;
    ownerID?: string;
    entityCategoryID?: string;
    name?: string;
  };
  body?: {
    excludedProductIDs?: string[];
  };
};

export type FindProductsForReportQuantityType = {
  page: number;
  take: number;
  order?: any;

  entityCategoryID?: string;
  name?: string;
  status: number;
};

export type FindProductsQuery = {
  page?: number;
  take?: number;
  order?: any;
  status?: number | string;
  entityCategoryID?: string;
  name?: string;
  entityID?: string;
  reserved?: boolean;
  entitySubCategoryID?: string;
};

export type FindProductsForCreatePolicyQuery = {
  page: number;
  take: number;
  order?: any;
  entityCategoryID?: string;
  name?: string;
};

export type FindCollaboratorProductsType = {
  page: number;
  take: number;
  order?: any;
  collaboratorID?: string;
  ownerID?: string;
  entityCategoryID?: string;
  name?: string;
  entityIDs?: string[];
};

export interface CheckDuplicateProductCodeQuery {
  code: string;
  entityID?: string;
  entitySubCategoryID: string;
}

export interface GenerateProductCodeQuery {
  entityID?: string;
  entitySubCategoryID: string;
}

export interface CreateProductFromStandardDataBody {
  standardProcessID: string;
  standardProductIDs: string[];
  displayProductBrandName: boolean;
}
